import $http from "../axios";
import i18n from "../i18n";

const actions = {
  downloadProductsReport(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `get-products-report?storeId=${data.storeId}&filter=${data.productsFilter}`,
          {
            headers: {
              Accept:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            responseType: "arraybuffer"
          }
        )
        .then(res => {
          const blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const e = document.createEvent("MouseEvents");
          const a = document.createElement("a");
          const currentDate = new Date();
          const date = currentDate.getDate();
          const month = currentDate.getMonth() + 1;
          const year = currentDate.getFullYear();
          // eslint-disable-next-line prettier/prettier
          const yyyymmdd = `${year}-${month < 10 ? "0" + month : month}-${
            date < 10 ? "0" + date : date
          }`;
          const now = currentDate.toLocaleTimeString("pt-br", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
          });
          const filename = `${
            data.productsFilter === "all-products"
              ? i18n.t("report.productsAllProducts")
              : data.productsFilter === "store-products"
              ? `${i18n.t("report.productsStoreProducts")} ${data.storeName}`
              : data.productsFilter === "all-stores-products"
              ? i18n.t("report.productsAllStoresProducts")
              : data.productsFilter === "management-planogram"
              ? `${i18n.t("report.productsManagementPlanogram")} ${
                  data.storeName
                }`
              : data.productsFilter === "all-stores-management-planogram"
              ? i18n.t("report.productsAllStoresManagementPlanogram")
              : data.productsFilter === "operational-planogram"
              ? `${i18n.t("report.productsOperationalPlanogram")} ${
                  data.storeName
                }`
              : data.productsFilter === "all-stores-operational-planogram"
              ? i18n.t("report.productsAllStoresOperationalPlanogram")
              : i18n.t("report.products")
          } ${yyyymmdd}-${now}.xlsx`;
          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            a.download,
            a.href
          ];
          // eslint-disable-next-line prettier/prettier
          e.initEvent(
            "click",
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
          );
          a.dispatchEvent(e);
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  downloadVendingProductsReport(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(`get-vending-products-report?vendingId=${data.vendingId}`, {
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          },
          responseType: "arraybuffer"
        })
        .then(res => {
          const blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const e = document.createEvent("MouseEvents");
          const a = document.createElement("a");
          const currentDate = new Date();
          const date = currentDate.getDate();
          const month = currentDate.getMonth() + 1;
          const year = currentDate.getFullYear();
          // eslint-disable-next-line prettier/prettier
          const yyyymmdd = `${year}-${month < 10 ? "0" + month : month}-${
            date < 10 ? "0" + date : date
          }`;
          const now = currentDate.toLocaleTimeString("pt-br", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
          });
          const filename = `${i18n.t(
            "report.vendingProducts"
          )} ${yyyymmdd}-${now}.xlsx`;
          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            a.download,
            a.href
          ];
          // eslint-disable-next-line prettier/prettier
          e.initEvent(
            "click",
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
          );
          a.dispatchEvent(e);
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  downloadScaleProductsReport() {
    return new Promise((resolve, reject) => {
      $http
        .get(`get-scale-products-report`, {
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          },
          responseType: "arraybuffer"
        })
        .then(res => {
          const blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const e = document.createEvent("MouseEvents");
          const a = document.createElement("a");
          const currentDate = new Date();
          const date = currentDate.getDate();
          const month = currentDate.getMonth() + 1;
          const year = currentDate.getFullYear();
          // eslint-disable-next-line prettier/prettier
          const yyyymmdd = `${year}-${month < 10 ? "0" + month : month}-${
            date < 10 ? "0" + date : date
          }`;
          const now = currentDate.toLocaleTimeString("pt-br", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
          });
          const filename = `${i18n.t(
            "report.scaleProductsReport"
          )} ${yyyymmdd}-${now}.xlsx`;
          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            a.download,
            a.href
          ];
          // eslint-disable-next-line prettier/prettier
          e.initEvent(
            "click",
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
          );
          a.dispatchEvent(e);
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  downloadTransactionsReport(_, data) {
    const reportModel = data.reportModel || "transactions";

    return new Promise((resolve, reject) => {
      $http
        .get(
          `get-transactions-report?storeId=${
            data.storeId
          }&reportModel=${reportModel}&beginDate=${data.dates[0]}&endDate=${
            data.dates[1]
          }`,
          {
            headers: {
              Accept:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            responseType: "arraybuffer"
          }
        )
        .then(res => {
          const blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const e = document.createEvent("MouseEvents");
          const a = document.createElement("a");
          // eslint-disable-next-line prettier/prettier
          const filename = `${
            reportModel === "transactions-with-items"
              ? i18n.t("report.transactionsWithItemsReport")
              : i18n.t("report.transactionsReport")
          } ${data.storeName} ${data.dates[0]} - ${data.dates[1]}.xlsx`;
          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            a.download,
            a.href
          ];
          // eslint-disable-next-line prettier/prettier
          e.initEvent(
            "click",
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
          );
          a.dispatchEvent(e);
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  downloadSettlementReport(_, date) {
    return new Promise((resolve, reject) => {
      $http
        .get(`get-settlement-report?date=${date}`, {
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          },
          responseType: "arraybuffer"
        })
        .then(res => {
          const blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const e = document.createEvent("MouseEvents");
          const a = document.createElement("a");
          // eslint-disable-next-line prettier/prettier
          const filename = `${i18n.t("report.settlementReport")} ${date}.xlsx`;
          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            a.download,
            a.href
          ];
          // eslint-disable-next-line prettier/prettier
          e.initEvent(
            "click",
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
          );
          a.dispatchEvent(e);
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  downloadInventoryRefill(_, refill) {
    return new Promise((resolve, reject) => {
      $http
        .get(`get-inventory-refill?refillId=${refill._id}`, {
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          },
          responseType: "arraybuffer"
        })
        .then(res => {
          const blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const e = document.createEvent("MouseEvents");
          const a = document.createElement("a");
          // eslint-disable-next-line prettier/prettier
          const filename = `${
            refill.operation === "inventory"
              ? i18n.t("report.inventoryRefillInventory")
              : refill.operation === "loss"
              ? i18n.t("report.inventoryRefillLoss")
              : `${i18n.t("report.inventoryRefill")}${
                  refill.originStore &&
                  refill.originStore.storeInfo &&
                  refill.originStore.storeInfo.name
                    ? ` ${refill.originStore.storeInfo.name} →`
                    : refill.origin === "direct-from-market"
                    ? i18n.t("report.inventoryRefillDirectFromMarket")
                    : ""
                }`
          } ${refill.store.storeInfo.name} ${refill.createdAt.substring(
            0,
            10
          )}.xlsx`;
          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            a.download,
            a.href
          ];
          // eslint-disable-next-line prettier/prettier
          e.initEvent(
            "click",
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
          );
          a.dispatchEvent(e);
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  downloadInventoriesRefillsReport(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `get-inventories-refills-report?beginDate=${data.dates[0]}&endDate=${
            data.dates[1]
          }&storeId=${data.storeId || ""}`,
          {
            headers: {
              Accept:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            responseType: "arraybuffer"
          }
        )
        .then(res => {
          const blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const e = document.createEvent("MouseEvents");
          const a = document.createElement("a");
          // eslint-disable-next-line prettier/prettier
          const filename = `${i18n.t("report.inventoriesRefills")} ${
            data.dates[0]
          } - ${data.dates[1]}.xlsx`;
          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            a.download,
            a.href
          ];
          // eslint-disable-next-line prettier/prettier
          e.initEvent(
            "click",
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
          );
          a.dispatchEvent(e);
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  downloadAccessesReport(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `get-accesses-report?storeId=${data.storeId}&beginDate=${
            data.dates[0]
          }&endDate=${data.dates[1]}&filter=${data.filter}`,
          {
            headers: {
              Accept:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            responseType: "arraybuffer"
          }
        )
        .then(res => {
          const blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const e = document.createEvent("MouseEvents");
          const a = document.createElement("a");
          // eslint-disable-next-line prettier/prettier
          const filename = `${
            data.filter === "rejected-accesses"
              ? i18n.t("report.accessesRejectedAccesses")
              : data.filter === "suspect-accesses"
              ? i18n.t("report.accessesSuspectAccesses")
              : i18n.t("report.accesses")
          } ${data.storeName} ${data.dates[0]} - ${data.dates[1]}.xlsx`;
          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            a.download,
            a.href
          ];
          // eslint-disable-next-line prettier/prettier
          e.initEvent(
            "click",
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
          );
          a.dispatchEvent(e);
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  downloadStockoutsReport(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `get-stockouts-report?beginDate=${data.beginDate}&endDate=${data.endDate}`,
          {
            headers: {
              Accept:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            responseType: "arraybuffer"
          }
        )
        .then(res => {
          const blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const e = document.createEvent("MouseEvents");
          const a = document.createElement("a");
          // eslint-disable-next-line prettier/prettier
          const filename = `Stockouts ${data.beginDate} - ${data.endDate}.xlsx`;
          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            a.download,
            a.href
          ];
          // eslint-disable-next-line prettier/prettier
          e.initEvent(
            "click",
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
          );
          a.dispatchEvent(e);
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  downloadFeedbacksReport(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `get-feedbacks-report?storeId=${data.storeId}&beginDate=${
            data.dates[0]
          }&endDate=${data.dates[1]}`,
          {
            headers: {
              Accept:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            responseType: "arraybuffer"
          }
        )
        .then(res => {
          const blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const e = document.createEvent("MouseEvents");
          const a = document.createElement("a");
          // eslint-disable-next-line prettier/prettier
          const filename = `${i18n.t("report.feedbacks")} ${data.storeName} ${
            data.dates[0]
          } - ${data.dates[1]}.xlsx`;
          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            a.download,
            a.href
          ];
          // eslint-disable-next-line prettier/prettier
          e.initEvent(
            "click",
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
          );
          a.dispatchEvent(e);
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  downloadPurchasesReport() {
    return new Promise((resolve, reject) => {
      $http
        .get(`get-purchases-report`, {
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          },
          responseType: "arraybuffer"
        })
        .then(res => {
          const blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const e = document.createEvent("MouseEvents");
          const a = document.createElement("a");
          // eslint-disable-next-line prettier/prettier
          const filename = i18n.t("report.purchases");
          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            a.download,
            a.href
          ];
          // eslint-disable-next-line prettier/prettier
          e.initEvent(
            "click",
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
          );
          a.dispatchEvent(e);
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  downloadLockerDeliveriesReport(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `get-locker-deliveries-report?lockerId=${data.lockerId}&filter=${data.filter}`,
          {
            headers: {
              Accept:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            responseType: "arraybuffer"
          }
        )
        .then(res => {
          const blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const e = document.createEvent("MouseEvents");
          const a = document.createElement("a");
          // eslint-disable-next-line prettier/prettier
          const filename =
            data.filter === "open-deliveries"
              ? `${i18n.t("report.lockerDeliveriesOpenDeliveries")} - ${
                  data.lockerName
                }.xlsx`
              : `${i18n.t("report.lockerDeliveriesAllDeliveries")} - ${
                  data.lockerName
                }.xlsx`;
          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            a.download,
            a.href
          ];
          // eslint-disable-next-line prettier/prettier
          e.initEvent(
            "click",
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
          );
          a.dispatchEvent(e);
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

export default {
  actions
};
